import axios, {AxiosError, AxiosInstance} from 'axios'
import _ from 'lodash'
import {AP_CART_PATH, RECAPTCHA_ENABLED,} from '../environment'
import RecaptchaRequiredError from '../errors/RecaptchaRequiredError'
import {Cart} from "../components/aerialphotography-components/ap.types";
import {generateRecaptchaToken} from "../common/recapctcha";

const AXIOS_CONFIG = {
  headers: {'X-RDS-AJAX': 'true', 'Accept-Language': 'en-AU'},
  baseURL: AP_CART_PATH,
  withCredentials: true,
}

class CartServiceAPI {

  client: AxiosInstance

  constructor() {
    this.client = axios.create(AXIOS_CONFIG)
  }

  postCart = async (cart: Cart) => {

    if (RECAPTCHA_ENABLED) {
      const isV3recaptcha = true // TODO, find out how we determine this
      const recaptchaToken = await generateRecaptchaToken() // should return a v3 code if no args

      return await this.client.post('/submit', cart, {
        params: {
          [isV3recaptcha ? 'recaptchaV3Key' : 'recaptchaV2Key']: recaptchaToken,
        }
      })
    } else {
      return await this.client.post('/submit', cart, )
    }
  }
}

const cartServiceAPI = new CartServiceAPI()

export default cartServiceAPI